import React from 'react';
import { GiftIcon, SparklesIcon, TrophyIcon, CalendarIcon } from 'lucide-react';
export function PromotionBanner() {
  return <div className="relative overflow-hidden bg-gradient-to-r from-red-700 via-red-600 to-amber-600 rounded-2xl shadow-2xl p-8 text-white" data-id="element-100">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -mr-32 -mt-32" data-id="element-101"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full -ml-24 -mb-24" data-id="element-102"></div>
      <div className="relative z-10" data-id="element-103">
        <div className="flex items-start justify-between flex-wrap gap-6" data-id="element-104">
          <div className="flex items-start gap-4 flex-1" data-id="element-105">
            <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 animate-bounce" data-id="element-106">
              <GiftIcon className="w-8 h-8" data-id="element-107" />
            </div>
            <div data-id="element-108">
              <div className="flex items-center gap-2 mb-2" data-id="element-109">
                <SparklesIcon className="w-5 h-5" data-id="element-110" />
                <h3 className="text-2xl font-bold" data-id="element-111">
                  Seasonal Promotions & Special Packages
                </h3>
              </div>
              <p className="text-white/90 text-lg mb-3" data-id="element-112">
                Discover exclusive dining experiences, seasonal menus, and
                special event packages
              </p>
              <div className="flex flex-wrap gap-3" data-id="element-113">
                <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full" data-id="element-114">
                  <CalendarIcon className="w-4 h-4" data-id="element-115" />
                  <span className="font-semibold text-sm" data-id="element-116">
                    🌙 Ramadan Iftar Specials
                  </span>
                </div>
                <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full" data-id="element-117">
                  <TrophyIcon className="w-4 h-4" data-id="element-118" />
                  <span className="font-semibold text-sm" data-id="element-119">
                    Lucky Draws & Rewards
                  </span>
                </div>
                <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full" data-id="element-120">
                  <span className="font-semibold text-sm" data-id="element-121">
                    🎉 Weekend Brunches
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}